import React, { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import {
    LegendModule,
    TimeAxisModule,
    LineSeriesModule,
    ModuleRegistry,
    NumberAxisModule,
} from 'ag-charts-enterprise';
import { Modal, Button, Spin } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import { DetectionEventsChartLogic } from './DetectionEventsChart';
import './DetectionEventsChart.scss';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

ModuleRegistry.registerModules([
    TimeAxisModule,
    LegendModule,
    LineSeriesModule,
    NumberAxisModule,
]);

function DetectionEventsChart({ startAndEndUnixDatesParams, formatDateRange }) {
    const { chartConfig, loading } = DetectionEventsChartLogic(startAndEndUnixDatesParams, formatDateRange);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Spin spinning={loading} indicator={<LoadingOrbitalSpinner />}>
            <div className='events-by-detection-chart'>
                <div className='events-by-detection-chart-wrapper'>
                    <Button
                        className='events-by-detection-chart-expand-btn'
                        type='text'
                        size='small'
                        icon={<ExpandAltOutlined />}
                        onClick={() => setModalOpen(true)}
                    />
                    {chartConfig && <AgCharts options={chartConfig} />}
                </div>
                <Modal
                    centered
                    open={modalOpen}
                    onCancel={() => setModalOpen(false)}
                    footer={null}
                    width='90%'
                >
                    {chartConfig && <AgCharts options={chartConfig} style={{ height: '70vh' }} />}
                </Modal>
            </div>
        </Spin>
    );
}

export default DetectionEventsChart;
